<template>
    <div class="widget" v-if="$store.state.modules.indexOf('crm.person')>=0">
        <h2 class="title">Profiles</h2>
        <div class="showbox" v-if="!profiles">
            <div class="loader">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                </svg>
            </div>
        </div>
        <div class="widget-content" v-if="profiles">
            <i class="icon icon-icon_person"></i>
            <div class="count"><span>total</span>{{ profiles.length }}</div>
            <spline :dataset="dataset" v-if="dataset"></spline>
            <div class="buttons">
                <router-link :to="{name:'person'}"><span>Voir la liste</span></router-link>
            </div>
        </div>
    </div>
</template>
<script>

    import PersonService from './PersonService.js';

    //import VueCharts from 'vue-chartjs'
    import Spline from '../../components/chart/Spline.vue'

    export default {
        name: 'Widget',
        components: {
            'spline' : Spline
        },
        data () {
            return {
                profiles: null
            }
        },
        mounted: function(){
            PersonService.query().then((response) => {
                this.profiles = response.data.data
            })
        },
        watch: {
            '$store.getters.scope'(newId, oldId) {
                PersonService.query().then((response) => {
                    this.profiles = response.data.data
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/person/PersonWidget.vue